import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivate } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Injectable()
export class CanActivateWithBrandInformation implements CanActivate {
  languageBrandRequiredSubscription: Subscription;
  brandRequiredText = '';

  constructor(
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
  ) {
    this.languageBrandRequiredSubscription = this.translateService
      .stream('app.nav.pleaseSelectABrand')
      .subscribe((val) => {
        this.brandRequiredText = val;
      });
  }

  canActivate() {
    if (this.hasBrand()) {
      return true;
    } else {
      this.snackBar.open(this.brandRequiredText, '', { duration: 3000, verticalPosition: 'top' });
      return false;
    }
  }

  hasBrand() {
    if (this.getBrand()) {
      return true;
    } else {
      return false;
    }
  }

  getBrand() {
    return window.sessionStorage.brand_id;
  }
}
